<template>
  <div style="border: 1px solid #999" class="pa-2">
    <div class="v-label theme--light pb-2">{{ ctrlTitle }}</div>
    <v-chip
      label
      close
      class="mt-2"
      v-for="(item, index) in value"
      :key="index"
      @click="edit(item)"
      @click:close="remove(index)"
      >{{ item.name }} {{ item.compare }} {{ item.value }}
      {{ item.and ? "and" : "or" }}</v-chip
    >
    <v-chip
      color="primary"
      title="Add Filter"
      @click="add"
      :disabled="!table"
      class="mt-2"
    >
      <v-icon>mdi-plus</v-icon>
    </v-chip>
    <v-dialog v-model="dialog" width="400" scrollable>
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="customField"
                  v-model="dataName"
                  hide-details
                  filled
                  label="Field Name"
                ></v-text-field>
                <FieldPicker
                  v-else
                  v-model="dataName"
                  :table="table"
                  :component="component"
                  source="field"
                  title="Select Field"
                  @type-change="typeChange"
                />
                <v-checkbox
                  dense
                  hide-details
                  label="Custom field"
                  v-model="customField"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <ComparisonPicker v-model="dataCompare" title="Comparison" />
              </v-col>
              <v-col cols="12">
                <FieldValuePickerBase
                  v-model="dataValue"
                  title="Value"
                  :component="component"
                  :containers="containers"
                  :type="dataType"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  hide-details
                  label="And"
                  v-model="dataAnd"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  hide-details
                  label="Input"
                  v-model="dataIsInput"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save" :disabled="!dataName"
            >OK</v-btn
          >
          <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldPicker from "./FieldPicker.vue";
import ComparisonPicker from "./ComparisonPicker.vue";
import FieldValuePickerBase from "./FieldValuePickerBase.vue";

export default {
  name: "FilterDesigner",

  components: { ComparisonPicker, FieldValuePickerBase, FieldPicker },

  props: ["title", "value", "table", "component", "containers"],

  data() {
    return {
      dialog: false,
      dataName: null,
      dataCompare: "=",
      dataValue: null,
      dataAnd: false,
      dataType: "text",
      items: [],
      dialogTitle: "",
      editingItem: null,
      customField: false,
      dataIsInput: false,
    };
  },

  computed: {
    ctrlTitle() {
      return this.title ? this.title : "Filters";
    },
  },

  watch: {
    value(v) {
      if (v) this.items = v;
    },
  },

  created() {
    if (this.value) this.items = this.value;
  },

  methods: {
    add() {
      this.dialogTitle = "Add";
      this.dataCompare = "=";
      this.dataName = null;
      this.dataValue = null;
      this.dataAnd = false;
      this.dataType = "text";
      this.dialog = true;
      this.editingItem = null;
      this.dataIsInput = false;
    },
    edit(item) {
      this.editingItem = item;
      this.dialogTitle = "Edit";
      this.dataCompare = item.compare;
      this.dataName = item.name;
      this.dataValue = item.value;
      this.dataAnd = item.and;
      this.dataType = item.valueType;
      this.customField = item.custom;
      this.dialog = true;
      this.dataIsInput = item.isInput;
    },
    save() {
      if (this.editingItem) {
        this.editingItem.name = this.dataName;
        this.editingItem.compare = this.dataCompare;
        this.editingItem.value = this.dataValue;
        this.editingItem.and = this.dataAnd;
        this.editingItem.valueType = this.dataType;
        this.editingItem.custom = this.customField;
        this.editingItem.isInput = this.dataIsInput;
      } else {
        this.items.push({
          name: this.dataName,
          compare: this.dataCompare,
          value: this.dataValue,
          and: this.dataAnd,
          valueType: this.dataType,
          custom: this.customField,
          isInput: this.dataIsInput,
        });
      }

      this.dialog = false;
      this.$emit("input", this.items);
    },
    typeChange(t) {
      this.dataValue = null;
      this.dataType = t;
    },
    remove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
  },
};
</script>
